import { __extends } from "tslib";
import { Entity } from '../../base/ddd-types/entity';
import { NotifyPadInfo } from '../value-object/notify-pad-info';
import { NotifyUserInfo } from '../value-object/notify-user-info';
var Notify = /** @class */ (function (_super) {
    __extends(Notify, _super);
    function Notify() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notifyUserInfo = new NotifyUserInfo({});
        _this.notifyPadInfo = new NotifyPadInfo({});
        _this.aRightFlag = 0;
        _this.bRightFlag = 0;
        _this.nRightFlag = 0;
        _this.rightFlag = 0;
        _this.denyCount = 0;
        _this.flag = 0;
        _this.id = '';
        _this.op = '';
        _this.pass = 0;
        _this.sendDate = 0;
        _this.subject = '';
        _this.type = 0;
        return _this;
    }
    Notify.prototype.initWithJsonObj = function (jsonObj) {
        if (!jsonObj) {
            Notify.logger.debug('params erroro: initWithJsonObj');
            return;
        }
        this.aRightFlag = jsonObj.aRightFlag;
        this.bRightFlag = jsonObj.bRightFlag;
        this.nRightFlag = jsonObj.nRightFlag;
        this.rightFlag = jsonObj.rightFlag;
        this.denyCount = jsonObj.denyCount;
        this.flag = jsonObj.flag;
        this.pass = jsonObj.pass;
        this.sendDate = jsonObj.send_date;
        this.type = jsonObj.type;
        this.id = jsonObj.id;
        this.op = jsonObj.op;
        this.subject = jsonObj.subject;
        this.notifyPadInfo = new NotifyPadInfo(jsonObj);
        this.notifyUserInfo = new NotifyUserInfo(jsonObj);
    };
    return Notify;
}(Entity));
export { Notify };
